import LayoutContentArea from "@/components/layout/LayoutContentArea";
import { AgencyDataSearchView } from "@/components/state-level/agency-data/AgencyDataSearchView";

export default function LeaDataViewPage() {
  return (
    <LayoutContentArea headingText="LEA Data View">
      <AgencyDataSearchView />
    </LayoutContentArea>
  );
}
